<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<div *ngIf="!loading">

  <!-- Header -->
  <div class="glv-header mb-4">
    <a class="glv-back-btn"
      [routerLink]="(platformSrv.platform.getIsExam() || langTgtSrv.current?.displayLevels)
        ? ['/', langSrcSrv.current.shortCode, 'games']
        : ['/', langSrcSrv.current.shortCode, 'games', idSection]">
      <i class="fa-solid fa-arrow-left"></i>
      <span *ngIf="!langTgtSrv.current?.displayLevels" translate>Niveaux</span>
      <span *ngIf="langTgtSrv.current?.displayLevels" translate>Parcours</span>
    </a>
    <h2 class="glv-level-name">{{ level.name }}</h2>
    <div class="glv-header-spacer"></div>
  </div>

  <ng-container *ngIf="!level.locked">

    <!-- Resource cards -->
    <div class="glv-resources mb-4"
      *ngIf="(!level.hideWord) || (lessons?.length && !level.hideLesson) || cultures?.length">
      <div
        class="glv-resource-card"
        *ngIf="!level.hideWord"
        (click)="openVocabulary()">
        <div class="glv-resource-icon glv-resource-icon-vocab">
          <i class="fa-solid fa-book-open"></i>
        </div>
        <div class="glv-resource-body">
          <div class="glv-resource-title" translate>Vocabulaire</div>
          <div class="glv-resource-sub" translate>Nouveau vocabulaire du niveau</div>
        </div>
        <i class="fa-solid fa-chevron-right glv-resource-arrow"></i>
      </div>

      <div
        class="glv-resource-card"
        *ngIf="lessons?.length && !level.hideLesson"
        (click)="openLessons()">
        <div class="glv-resource-icon glv-resource-icon-lessons">
          <i class="fa-solid fa-graduation-cap"></i>
        </div>
        <div class="glv-resource-body">
          <div class="glv-resource-title" translate>Leçons</div>
          <div class="glv-resource-sub" translate>Apprends de nouvelles règles</div>
        </div>
        <i class="fa-solid fa-chevron-right glv-resource-arrow"></i>
      </div>

      <div
        class="glv-resource-card"
        *ngIf="cultures?.length"
        (click)="openCultures()">
        <div class="glv-resource-icon glv-resource-icon-culture">
          <i class="fa-solid fa-earth-europe" *ngIf="!platformSrv.platform.getIsExam()"></i>
          <i class="fa-solid fa-lightbulb" *ngIf="platformSrv.platform.getIsExam()"></i>
        </div>
        <div class="glv-resource-body">
          <div class="glv-resource-title">
            <span *ngIf="!platformSrv.platform.getIsExam()" translate>Point culture</span>
            <span *ngIf="platformSrv.platform.getIsExam()" translate>Conseils</span>
          </div>
          <div class="glv-resource-sub">
            <span *ngIf="!platformSrv.platform.getIsExam()" translate>Us & Coutumes et plus encore</span>
            <span *ngIf="platformSrv.platform.getIsExam()" translate>Conseils pour la certification</span>
          </div>
        </div>
        <i class="fa-solid fa-chevron-right glv-resource-arrow"></i>
      </div>
    </div>

    <!-- Games -->
    <ng-container *ngIf="games">

      <!-- Training games -->
      <ng-container *ngIf="getTrainingGames().length">
        <div class="glv-section-label mb-3">
          <i class="fa-solid fa-eye"></i>
          <span translate>Découverte</span>
        </div>
        <div class="row mb-4">
          <div class="col-6 col-md-4 col-lg-3 mb-3"
            *ngFor="let game of getTrainingGames() | sortBy:'position'; trackBy: trackById">
            <app-game-item [game]="game" (open)="openGame(game.uniqid)"></app-game-item>
          </div>
        </div>
      </ng-container>

      <!-- Classic / evaluation games -->
      <ng-container *ngIf="getClassicGames().length">
        <div class="glv-section-label glv-section-label-eval mb-3">
          <i class="fa-solid fa-chart-line"></i>
          <span translate>Progression</span>
        </div>
        <div class="row">
          <div class="col-6 col-md-4 col-lg-3 mb-3"
            *ngFor="let game of getClassicGames() | sortBy:'position'; trackBy: trackById">
            <app-game-item [game]="game" (open)="openGame(game.uniqid)"></app-game-item>
          </div>
        </div>
      </ng-container>

    </ng-container>

  </ng-container>

</div>
